export var l = 'LOCATION';
var actions = ["GET_".concat(l, "_LIST_REQUEST"), "GET_".concat(l, "_LIST_SUCCESS"), "GET_".concat(l, "_LIST_FAILURE"), "GET_ONE_".concat(l, "_REQUEST"), "GET_ONE_".concat(l, "_SUCCESS"), "GET_ONE_".concat(l, "_FAILURE")];
var actionTypes = actions.reduce(function (acc, x) {
  acc[x] = x;
  return acc;
}, {});
export default actionTypes;